{
  "title": "WebRTC Call Stats",
  "loading": "Loading",
  "disconnected": "Disconnected",
  "lastUpdate": "Last Update",
  "refresh": "Refresh",
  "signalRConnections": "SignalR Connections",
  "webCalls": "Web Calls",
  "proxyConnections": "Proxy Connections"
}
